import axios from "axios";
import { cDatabaseApi, cDbQuery } from "./DatabaseApi";
import { User } from "./User";

export class cUserApi {
  public static async initUserApi() {
    cDatabaseApi.initDatabaseApi("Geminai");
  }

  public static async addUser(user: User): Promise<boolean> {
    const q = new cDbQuery("Users");
    q.setData(user);
    const status = await cDatabaseApi.add(q);
    return status;
  }

  public static async getUser() {
    const q = new cDbQuery("Users");
    const dbRows = await cDatabaseApi.query(q);
    return dbRows;
  }

  public static async getUserWithEmail(email: string) {
    const q = new cDbQuery("Users");
    q.setWhere("Email", email);
    const dbRows = await cDatabaseApi.query(q);
    return dbRows;
  }

  public static async updateUser(user: User): Promise<boolean> {
    const q = new cDbQuery("Users");
    q.setWhere("email", user.email);
    q.setData(user);
    const status = await cDatabaseApi.update(q);

    return status;
  }
  public static async deleteUser(user: User): Promise<boolean> {
    const q = new cDbQuery("Users");
    q.setWhere("email", user.email);
    const status = await cDatabaseApi.delete(q);

    return status;
  }

  public static async decryptPassword(password: any): Promise<string> {

    const response =  await axios.post(`${process.env.IMJS_BACKEND}/decrypt`, password);
    return response.data;
  }
}
